import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';

export default function About() {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50">
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-20 md:pt-24 pb-10 md:pb-16 px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="animate-fade-in-left order-2 md:order-1">
              <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4 md:mb-6">
                저희 그린디자인테크는...
              </h1>
              <p className="text-base md:text-xl text-gray-600 mb-6 md:mb-8 leading-relaxed">
                디자인과 기술을 결합하여 지속 가능한 솔루션을 제안하는 기업입니다. 3D 모델링과 디자인 시안을 통해 기획 단계에서부터 설치 단계까지 전 과정에서 효율과 완성도를 높이고 현장 조건과 목적에 맞춘 최적의 결과를 제공하는 것을 목표로 하고 있습니다.
              </p>
              <div className="flex gap-4">
                <Link to="/contact" onClick={handleLinkClick}>
                  <Button variant="primary">견적 문의</Button>
                </Link>
              </div>
            </div>
            
            <div 
              className="rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500 animate-fade-in-right order-1 md:order-2 h-64 md:h-[500px]"
              style={{
                backgroundImage: `url('https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/e9573c15da758a3fdc766ef7f45a5bfd.png')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            >
            </div>
          </div>
        </div>
      </section>
      
      {/* Story Timeline */}
      <section className="py-12 md:py-20 px-4 md:px-8 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-bold text-center text-gray-800 mb-10 md:mb-16">찾아오시는 길</h2>
          
          <div className="space-y-6">
            {/* Address Info */}
            <div className="flex items-center gap-4 justify-center">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-fill text-white text-lg md:text-xl"></i>
              </div>
              <div>
                <p className="text-base md:text-lg font-semibold text-gray-800">경기도 김포시 대곶면 쇄암로 144</p>
              </div>
            </div>
            
            {/* Google Map */}
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3165.8!2d126.5847!3d37.6234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9e8a8a8a8a8a%3A0x0!2z6rK96riw64-EIOq5gO2PrOyLnCDrjIDqs7brqbQg7IeE7JWU66GcIDE0NA!5e0!3m2!1sko!2skr!4v1699999999999!5m2!1sko!2skr"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="그린디자인테크 위치"
                className="w-full h-[300px] md:h-[450px]"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
      
      {/* Explore More Section */}
      <section className="py-12 md:py-20 px-4 md:px-8 bg-gradient-to-r from-emerald-500 to-teal-500">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6">자연을 설계, 공간의 가치를 완성</h2>
          <p className="text-base md:text-xl mb-6 md:mb-8 leading-relaxed px-2">
            Harmony of Nature and Technology
          </p>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}
